import { getContainerData, loadMorePosts } from '../helpers/more';

export default () => {
  const sections = document.querySelectorAll('.c-works[data-more]');

  if (sections.length < 1) {
    return;
  }

  [].forEach.call(sections, section => {
    const data = getContainerData(section);

    if (
      data.button === null ||
      data.dataContainer === null ||
      data.container === null
    ) {
      return;
    }

    data.success = () => {
      data.info.page += 1;
    };

    data.button.addEventListener('click', event => {
      event.preventDefault();
      if (data.info.page < 2) {
        data.info.page = 2;
      }
      loadMorePosts(data);
    });
  });
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/elefint-redesign-chisel/src/scripts/modules/works.js